<template>
  <div class="component-form-button">
    <a-button
      :disabled="cancelIsDisabled"
      class="cancel-button"
      shape="round"
      @click="$emit('onCancel')"
    >
      {{ cancelText }}
    </a-button>
    <a-button
      v-show="submitIsShow"
      :loading="btnIsLoading"
      class="save-button"
      type="primary"
      shape="round"
      @click="$emit('onSubmit')"
    >
      {{ submitText }}
    </a-button>
    
	<a-button
    v-show="submitIsShow"
	  type="primary"
	  class="save-button"
		shape="round"
		@click="$emit('handlereject')"
		:disabled="!hasSelected"
	>
	  批量驳回
	</a-button>
	<a-button
    v-show="submitIsShow"
	  type="primary"
	  class="save-button"
		shape="round"
		:disabled="!hasSelected"
		@click="$emit('handlesubmit')"
	>
			批量通过
	</a-button>

  </div>
</template>
<script>
export default {
  props: {
	  hasSelected:{
		  default: false,
	  },
    submitText: {
      default: '提交验收',
    },
    cancelText: {
      default: '返回',
    },
    submitIsShow: {
      default: false,
    },
    cancelIsDisabled: {
      default: false,
    },
    btnIsLoading: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.component-form-button {
  height: 80px;
  line-height: 80px;
  background: #f9f9fc;
  margin: 20px -32px -24px;
  padding: 0 24px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .required-message {
    span {
      color: #ff5075;
      display: inline-block;
      width: 9px;
    }
  }
  .save-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
  .cancel-button {
    float: right;
    margin-left: 10px;
    margin-top: 20px;
    width: 104px;
  }
}
</style>
